export default __webpack_public_path__ + "static/media/20 Mobility Videos.5d47952c.png";